var BaseApiService = /** @class */ (function () {
    function BaseApiService(config) {
        this.url = config.url;
    }
    return BaseApiService;
}());

export { BaseApiService };
